import React from 'react';
import PropTypes from "prop-types";

import LiveSearch from '../LiveSearch';
import Api from '../../Api';

import SearchIcon from '../../images/icons/search.svg';

import './style.less';

export default class TopSearch extends React.Component {
  static propTypes = {
    className: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.focus = this.focus.bind(this);

    this.state = {
      visible: false,
      searchTerm: ''
    };
  }

  componentWillMount() {
    Api.startListen(this, 'visible', Api.cache.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED);
    Api.startListen(this, 'searchTerm', Api.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
  }

  componentWillUnmount() {
    Api.stopListen(this, Api.cache.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
  }

  componentDidUpdate(oldProps, oldState) {
    if (this.state.visible && !oldState.visible) {
      this.focus();
    }

    if (!this.state.visible && oldState.visible) {
      // Once the search is hidden, clear the search value.
      Api.cache.setProductSearchTerm('');
    }
  }

  focus() {
    setTimeout(() => {
      document.getElementById('top-search').focus();
    }, 50);
  }

  toggle() {
    Api.cache.setProductSearchActive(!this.state.visible);
  }

  onChange(value) {
    Api.cache.setProductSearchTerm(value);
  }

  render() {
    let classNames = [ 'topsearch-component' ];
    if (this.props.className) {
      classNames.push(this.props.className);
    }

    return(
      <div className={classNames.join(' ')}>
        <div className="search-icon" onClick={this.toggle}><img role="presentation" src={SearchIcon} /></div>
        <div className={'search-input' + (this.state.visible ? '' : ' hidden')}>
          <LiveSearch id="top-search" onChange={this.onChange} value={this.state.searchTerm} />
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/TopSearch/index.js
 **/